import BaseComponentV2 from '../../../../../../library/js/components/base-component-v2';
/**
 * GoogleMap's Place Suggestions.
 */
export default class AddressSelectionComponent extends BaseComponentV2 {

  /**
   * If '[name="inputName"]' already exists within the DOM, it's value is captured and the element
   * is removed from the DOM.
   *
   * @param element Target HTML element on the DOM, to insert component into.
   * @param inputName Name of 'hidden' input.
   * @param placeIdInput name of 'hidden' input for placeId
   * @param placeholderName name of placeholder link to select address
   */
  constructor(element, inputName, placeIdInput, placeholderName = 'Select Address') {

    super(element);

    this.inputName = inputName;
    this.placeIdInput = placeIdInput;
    this.placeholderName = placeholderName;

    this.element.data('component', this);
    this.inputValue = this.getData('selected-address');
    this.inputPlaceIdValue = this.getData('selected-place-id');
    this.error = this.getData('error');

    this.renderHTML();

    const addressButton = this.element.find('#addressButton');
    const changeButton = this.element.find('.changeButton');
    const cancelButton = this.element.find('.cancelButton');

    const addressNotSelectedDiv = this.element.find('.addressNotSelected');
    const addressSelectionDiv = this.element.find('.addressSelection');
    const addressSelectionInput = $(addressSelectionDiv.find('input')[0]);
    const addressSelectedDiv = this.element.find('.addressSelected');

    const autocompleteElement = this.element.find('input');

    const selectedAddressElement = this.element.find('#selectedAddress');
    const hiddenElement = this.element.find('[name="' + inputName + '"]');

    addressButton.on('click', function() {
      addressNotSelectedDiv.hide();
      addressSelectionDiv.show();
      addressSelectionInput.focus();
    });

    autocompleteElement[0].addEventListener('keydown', function(event)  {
      if (event.keyCode == 13) {
        event.preventDefault();
      }
    });

    changeButton.on('click', function() {
      addressSelectedDiv.hide();
      addressSelectionDiv.show();
    });

    cancelButton.on('click', function() {
      addressSelectionDiv.hide();

      if (hiddenElement.val() !== '') {
        addressSelectedDiv.show();
      } else {
        addressNotSelectedDiv.show();
      }
    });

    const autocomplete = new google.maps.places.Autocomplete(autocompleteElement[0]);

    autocomplete.addListener('place_changed', (e) => {
      autocompleteElement.val('');

      const place = autocomplete.getPlace();
      this.element.find('[name="' + this.inputName + '"]').val(place.formatted_address);
      this.element.find('[name="' + this.placeIdInput + '"]').val(place.place_id);
      selectedAddressElement.html(place.formatted_address);

      addressSelectionDiv.hide();
      addressSelectedDiv.show();

      this.element.trigger('addressChanged', place.formatted_address);
    });

    /**
     * Google's Autocomplete class sets the inputs's autocomplete attribute to 'off' which does not
     * prevent the autofill dialog list to display. So we wait and then reset the attribute to 'new-password'
     * which prevents the autofill from working.
     */
    setTimeout(() => {
      autocompleteElement.attr('autocomplete', 'new-password');
    }, 500);

    if (this.inputValue != '' && this.inputPlaceIdValue != '') {
      selectedAddressElement.html(this.inputValue);
      addressNotSelectedDiv.hide();
      addressSelectedDiv.show();
    }
  }

  renderHTML() {

    const n = Math.floor(Math.random() * 10);

    const html = `
      <div class="error">${this.error}</div>
      <div class="addressNotSelected" style="position: relative;">
        <a class="form-control m-input b-all mt4 mb4 text-left medium-gray gray-link" id="addressButton" style="display: block; cursor:pointer; line-height: 39px;">${ this.placeholderName }</a>
      </div>
      <div class="addressSelected" style="display: none; position: relative;">
        <div id="selectedAddress" class="form-control m-input b-all mt4 mb4 text-left f4 pr7-lg" style="line-height: 34px; padding-top: 10px; font-size: 1.2em; padding-bottom: 45px; height: 30px; overflow: hidden; white-space: nowrap">..</div>
        <a class="changeButton sh-font f25 medium-gray gray-link" style="display: block; float: right; cursor: pointer; position: absolute; top: 0; right: 0; width: 100%; height: 100%;"></a>
      </div>
      <div class="addressSelection" style="display: none; position: relative;">
        <input class="form-control m-input b-all mt4 mb4 text-left black w100" placeholder="Search address.."/>
        <a class="cancelButton sh-font f25 medium-gray gray-link" style="display: block; float: right; cursor: pointer; position: absolute; top: 15px; right: 21px;">Cancel</a>
      </div>
      <input type="hidden" name="${this.inputName}" value="${this.inputValue}" />
      <input type="hidden" name="${this.placeIdInput}" value="${this.inputPlaceIdValue}" />
`;

    this.render(html);
  }
}
